import { getStationCode } from "../../../network/NetworkUtil";
import {
  getShiftPlanSettings,
  setShiftPlanSettings,
} from "../../../handler/ParentDataHandler";
import { logOperationalMetric } from "../../../overview/utils/utils";
import { metricProcessName } from "../../../util/Constants";

export async function fetchSsdAdminSettings(dispatcher) {
  const startTime = Date.now();
  try {
    const result = await getShiftPlanSettingsS3DownloadUrl();
    if (result.status === 200) {
      const preSignedUrl = result.data.url;
      const s3DownloadResponse = await fetch(preSignedUrl);
      if (s3DownloadResponse.status === 200) {
        const adminSettings = await s3DownloadResponse.json();
        logOperationalMetric(
          startTime,
          metricProcessName,
          "fetchSsdAdminSettings",
          true,
        );
        dispatcher({
          type: "RECEIVED_ADMIN_SETTINGS",
          data: adminSettings,
        });
      }
    }
  } catch (error) {
    const adminSettings = null;
    logOperationalMetric(
      startTime,
      metricProcessName,
      "fetchSsdAdminSettings",
      false,
    );
    dispatcher({
      type: "RECEIVED_ADMIN_SETTINGS",
      data: {
        adminSettings,
      },
    });
  }
}

export function getShiftPlanSettingsS3DownloadUrl() {
  const request = {
    operationType: "get",
    queryParams: "stationCode=" + getStationCode(),
  };
  return getShiftPlanSettings(request);
}

export function getShiftPlanSettingsS3UploadUrl() {
  const request = {
    operationType: "upload",
    queryParams: "stationCode=" + getStationCode(),
  };
  return setShiftPlanSettings(request);
}

export async function updateAdminSettings(adminSettings) {
  try {
    JSON.parse(JSON.stringify(adminSettings));
    const getS3UploadUrlResponse = await getShiftPlanSettingsS3UploadUrl();
    if (getS3UploadUrlResponse.status === 200) {
      const preSignedUrl = getS3UploadUrlResponse.data.url;
      const s3UploadResponse = await fetch(preSignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(adminSettings),
      });
      return s3UploadResponse;
    }
  } catch (e) {
    return { status: 500, error: e };
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/ssd/SsdSettingsNetworkAPI.js